import { MyteamsService } from './../_services/myteams.service';
import { Component, OnInit, OnDestroy, HostListener, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-standings',
  templateUrl: './standings.component.html',
  styleUrls: ['./standings.component.scss']
})

@HostListener('scroll', ['$event'])

export class StandingsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() contest: any;
  @Input() user: any;
  @Input() season: any;
  standingsLoadMore = false;
  standingsLoading = true;
  @Input() myEntries: boolean;
  @Input() mrFullStandings: boolean;
  standingsIndex = 0;
  standings = [];
  @Output() loadContestEmit = new EventEmitter<string>();
  sub_isMobileScreen: Subscription;
  isMobile = false;
  updateTimer: any = null;

  constructor(private _myTeamsService: MyteamsService, private store: Store<any>) {
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
    this.updateTimer = setInterval(() => {
      this.liveUpdate();
    }, 60000);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    clearInterval(this.updateTimer);
  }

  ngOnChanges(e) {
    // need to detect input changes for contest, myEntries, mrFullStandings
    if (e.contest != null) this.contest = e.contest.currentValue;
    if (e.mrFullStandings != null) this.mrFullStandings = e.mrFullStandings.currentValue;
    if (e.myEntries != null) this.myEntries = e.myEntries.currentValue;
    if (e.user != null) this.user = e.user.currentValue;
    this.startStandings();
  }

  standingsScroll(event) {
    if (!this.standingsLoadMore) {
      const top = event.target.scrollTop + event.target.clientHeight;
      const height = event.target.scrollHeight;
      const saved = event.target.scrollTop;
      if (top > height - 10) {
        // load more
        if (this.standingsIndex > -1) this.loadStandings(() => {
          event.target.scrollTop = saved;
        });
      }
    }
  }

  getHeight(element) {
    const top = element.getBoundingClientRect().top;
    const bottom = (!this.isMobile) ? 36 : 0; // My entries button size
    const wH = window.innerHeight;
    return wH - top - bottom - ((this.isMobile) ? 70 : 10);
  }

  startStandings() {
    this.standings = [];
    this.standingsIndex = 0;
    this.standingsLoading = true;
    this.loadStandings();
  }

  loadStandings(callback = null) {
    this.standingsLoadMore = true;
    if (this.contest.data._tour_id > 0 && this.contest.data.is_gpp == 'N') {
      // Multi-Round Tournament
      if (this.myEntries) {
        this._myTeamsService.getMyStandings((this.mrFullStandings) ? this.contest.data._tour_id : this.contest.data.league_id, (this.mrFullStandings) ? 'tournament' : 'league', this.user.id,this.season).subscribe(res => {
          if (res.status == 'success') {
            this.standings = res.entities;
            this.standingsIndex = -1;
          }
          this.standingsLoadMore = false;
          this.standingsLoading = false;
          if (callback != null) callback();
        });
      } else {
        // call service, store standings objects, remove standingsLoading, make magic
        this._myTeamsService.getStandings((this.mrFullStandings) ? this.contest.data._tour_id : this.contest.data.league_id, (this.mrFullStandings) ? 'tournament' : 'league', this.standingsIndex, 200, this.season).subscribe(res => {
          if (res.status == 'success') {
            this.standings = [...this.standings, ...res.entities];
            if (res.entities.length < 200) {
              this.standingsIndex = -1;
            } else {
              this.standingsIndex += 200;
            }
          }
          this.standingsLoadMore = false;
          this.standingsLoading = false;
          if (callback != null) callback();
        });
      }
    } else {
      if (this.myEntries) {
        this._myTeamsService.getMyStandings((this.contest.data._tour_id > 0) ? this.contest.data._tour_id : this.contest.data.league_id, (this.contest.data._tour_id > 0) ? 'tournament' : 'league', this.user.id,this.season).subscribe(res => {
          if (res.status == 'success') {
            this.standings = res.entities;
            this.standingsIndex = -1;
          }
          this.standingsLoadMore = false;
          this.standingsLoading = false;
          if (callback != null) callback();
        });
      } else {
        // call service, store standings objects, remove standingsLoading, make magic
        this._myTeamsService.getStandings((this.contest.data._tour_id > 0) ? this.contest.data._tour_id : this.contest.data.league_id, (this.contest.data._tour_id > 0) ? 'tournament' : 'league', this.standingsIndex, 200,this.season).subscribe(res => {
          if (res.status == 'success') {
            this.standings = [...this.standings, ...res.entities];
            if (res.entities.length < 200) {
              this.standingsIndex = -1;
            } else {
              this.standingsIndex += 200;
            }
          }
          this.standingsLoadMore = false;
          this.standingsLoading = false;
          if (callback != null) callback();
        });
      }
    }
  }

  showRank(contest, lgm) {
    if (contest.data._tour_id > 0 && contest.data.is_gpp == 'N') {
      // Multi-Round Tournament
      const count = this.standings.reduce((acc, o) => {
        if (this.mrFullStandings) {
          if (o.tour_rank == lgm.tour_rank) acc++;
        } else {
          if (o.team_rank == lgm.team_rank) acc++;
        }
        return acc;
      }, 0);
      if (count > 1) lgm.is_tie == 'Y';
      return (this.mrFullStandings) ? lgm.tour_rank : lgm.team_rank;
    } else {
      return (this.contest.data._tour_id > 0) ? lgm.tour_rank : lgm.team_rank;
    }
  }

  loadContest(slug) {
    this.loadContestEmit.emit(slug);
  }

  liveUpdate() {
    // current standings update
    const time = Math.floor(Date.now() / 1000);
    if (this.contest != null && this.contest.data.egs < time) {
      this._myTeamsService.liveStandings((this.contest.data._tour_id > 0) ? this.contest.data._tour_id : this.contest.data.league_id, (this.contest.data._tour_id > 0) ? 1 : 0, 0, (this.contest.data._tour_id > 0) ? this.contest.data.tour_entrants : this.contest.data.entrants, this.contest.data.duration_id, this.contest.data.game_id).subscribe(res => {
        if (res.status == 'success') {
          this.standings.forEach(s => {
            if (res.lgmData[s.lgm_id] != null) {
              if (this.contest.data._tour_id > 0) {
                s.tour_rank = res.lgmData[s.lgm_id].rank;
              } else {
                s.team_rank = res.lgmData[s.lgm_id].rank;
              }
              if (this.contest.data.duration_id == 8 && res.lgmData[s.lgm_id].this_week != null) {
                s.this_week = res.lgmData[s.lgm_id].this_week;
              }
              s.pmr = (res.lgmData[s.lgm_id].pmr != null) ? res.lgmData[s.lgm_id].pmr : s.pmr;
              s.team_total = res.lgmData[s.lgm_id].fpts;
              s.payout = res.lgmData[s.lgm_id].payout;
              s.is_tie = res.lgmData[s.lgm_id].is_tie;
            }
          });
          this.standings.sort((a, b) => {
            if (this.contest.data._tour_id > 0) {
              return a.tour_rank - b.tour_rank;
            } else {
              return a.team_rank - b.team_rank;
            }
          });
        }
      });
    }
  }

}
